import { toast } from "react-toastify";
import "../../node_modules/react-toastify/dist/ReactToastify.css";

export function notify(message, autoClose = true, type = "error", onClose) {
  toast(message, {
    type: type,
    autoClose,
    onClose,
    progressStyle: {
      height: "5px",
      backgroundColor: "rgba(255, 255, 255, 0.7)",
    },
  });
}
